define('modules/lp_integration/collections/mdirector_accounts',['require','exports','module','backbone','env'],function(require, exports, module){
  "use strict";
  var Backbone = require("backbone"),
      config = require("env");

  module.exports = Backbone.Collection.extend({
    url: function(){
      return config.apiHost + "/mdirector/accounts";
    }
  });
});
